@import '@helsenorge/designsystem-react/scss/_palette.scss';

.tablist {
  border-bottom: 2px solid;
  position: relative;
  padding-inline-start: 0px;
  margin-block-start: 48px;
}

.tab {
  border: 0;
  outline: none;
  -ms-flex-align: center;
  align-items: center;
  background-color: transparent;
  padding-left: 0;
  height: 100%;
  margin-right: 32px;
  padding-right: 0px;
  margin-bottom: 15px;
  padding-bottom: 1px;

  &:hover {
    outline: solid rgba($blueberry600, 0.1) 3px;
    background: rgba($blueberry600, 0.1);
  }

  &:focus {
    outline: solid black 3px;
  }

  &__icon {
    position: absolute;
    top: -6px;
  }

  &__icon-container {
    position: relative;
  }

  &__title {
    display: flex;
    align-items: center;
    text-align: left;
    border-bottom: 1px solid transparent;
    font-size: 1.125rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.45px;
    line-height: 24px;
    color: $blueberry600;
    fill: $blueberry600;

    &:hover {
      color: $blueberry700;
    }

    &--active {
      color: $black;
      fill: $black;

      &:hover {
        color: $black;
      }
    }
  }
}
